import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'redux';

import Gate from '../partials/Gate';
import FA from './fa';
import { dashboardPathForUser } from '../common/roleRoutes';
import { useTitle } from '../common/utils';

// Explicit "you can't view this" page. Rendered inline by PrivateRoute when a
// logged-in user's role isn't in a route's allowedRoles -- rendering in place
// (rather than redirecting) keeps the attempted URL visible, which matters for
// a link that was emailed to the wrong role: the recipient sees exactly what
// they tried to open and gets a one-click way back to their own dashboard.
const Unauthorized = ({ user }) => {
  useTitle('Not authorized');
  const home = dashboardPathForUser(user);
  return (
    <Gate boxWidthClass="col-md-6">
      <div
        className="login_box form-content container form-group"
        style={{ textAlign: 'center' }}
      >
        <h1 style={{ marginBottom: 16 }}>
          <FA color="gray" icon="lock" /> Access denied
        </h1>
        <p style={{ margin: '16px auto', maxWidth: 480 }}>
          You don't have permission to view this page. If you followed a link,
          it may have been meant for an account with a different role.
        </p>
        <div className="row btns-row">
          <div className="col-12 text-center">
            <Link
              className="btn btn-lg fs-14 btn-primary"
              to={home}
              style={{ width: '80%', marginBottom: 20 }}
            >
              Go to your dashboard
            </Link>
          </div>
        </div>
      </div>
    </Gate>
  );
};

export default compose(connect((state) => ({ user: state.auth.user })))(
  Unauthorized
);
